(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wf-cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wf-cart-upsell')) {
    class WfCartUpsell extends HTMLElement {
      connectedCallback() {
        if (this.wfBound) return;
        this.wfBound = true;
        this.addEventListener('submit', (event) => this.onSubmit(event));
        this.addEventListener('change', (event) => this.onChange(event));
      }

      onChange(event) {
        const select = event.target;
        if (!select || !select.matches('select[name="id"]')) return;
        const option = select.options[select.selectedIndex];
        const img = this.querySelector('[data-wf-img]');
        if (img && option && option.dataset.img) img.src = option.dataset.img;
      }

      async onSubmit(event) {
        const form = event.target;
        if (!form || !form.matches('form[data-wf-form]')) return;
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          const id = Number(new FormData(form).get('id'));
          const added = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
          });
          if (!added.ok) throw new Error('cart add failed');
          const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'wf-cart-upsell',
                data: { itemCount: cart.item_count, source: 'wf-cart-upsell' },
              },
            })
          );
        } catch (error) {
          form.submit();
        }
      }
    }
    customElements.define('wf-cart-upsell', WfCartUpsell);
  }
  } catch(e) { console.error(e); }
})();

})();
